/*
  Drives the EXISTING Anatomy Explorer (same-origin iframe) for Anatomy Recall —
  the web twin of the mobile WebView bridge. Uses `__microlabRecallSetState`
  and falls back to the plain quiz highlight on older explorer builds.
*/

const EMBED_CSS =
  ".structure-ask-ai,.anatomy-canvas .structure-ask-ai,.structure-callout-rule,.interaction-hint," +
  ".reset-cluster-row,.isolation-chip,.viewer-controls,.body-quiz-panel{display:none!important}" +
  ".viewer-dock,.viewer-chrome,.reset-cluster{pointer-events:none!important}";

export function explorerUrl({ systems, dark, lang }) {
  const params = new URLSearchParams({
    quiz: "1",
    embed: "1",
    recall: "1",
    theme: dark ? "dark" : "light",
    lang: lang || "en",
    systems: (systems || []).join(","),
  });
  return `/anatomy-explorer?${params.toString()}`;
}

function win(iframe) {
  try {
    return iframe?.contentWindow || null;
  } catch {
    return null;
  }
}

/** Hides explorer chrome Recall doesn't need. Safe to call repeatedly. */
export function prepareExplorer(iframe) {
  const w = win(iframe);
  const doc = w?.document;
  if (!doc?.documentElement) return;
  doc.documentElement.classList.add("anatomy-quiz-mode", "anatomy-embed");
  let style = doc.getElementById("microlab-recall-embed");
  if (!style) {
    style = doc.createElement("style");
    style.id = "microlab-recall-embed";
    (doc.head || doc.documentElement).appendChild(style);
  }
  style.textContent = EMBED_CSS;
}

/** { status: 'building'|'built', progress } once the explorer reports it. */
export function readBuild(iframe) {
  return win(iframe)?.__microlabLastAnatomyBuild || null;
}

export function setSystems(iframe, systems) {
  const w = win(iframe);
  if (systems?.length && w?.__microlabSetEnabledSystems) w.__microlabSetEnabledSystems(systems);
}

export function applyView(iframe, view) {
  const w = win(iframe);
  if (!w) return;
  const payload = {
    activeIds: view.activeIds,
    completedIds: view.completedIds,
    progress: Math.max(0, Math.min(1, view.progress)),
    focus: view.focus,
    angle: view.angle || 0,
  };
  if (w.__microlabRecallSetState) {
    w.__microlabRecallSetState(payload);
    return;
  }
  const lead = view.activeIds[0];
  if (lead && w.__microlabHighlightStructure) w.__microlabHighlightStructure(lead);
  else if (!lead && w.__microlabShowAll) w.__microlabShowAll();
}

/** Shows the explorer's name callout on the active structure (Reveal). */
export function setInspect(iframe, on) {
  win(iframe)?.document?.documentElement?.classList.toggle("anatomy-quiz-inspect", Boolean(on));
}
